import { Route } from '@angular/router';
import { RouterUtil } from '@us/web/shared/utils';
import { ContactPage } from './pages/contact/contact.page';

export const routes: Route[] = [{ path: RouterUtil.Cog.Contact, component: ContactPage }];
